// import { useState } from "react";
import SelectDropdown from "../../components-react/SelectDropdown";

const ApprovalStatusFilter = ({ selectedStatus, setSelectedStatus }) => {
  const statusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Done" },
    // { value: "2", label: "Rejected" },
  ];

  // console.log("selectedStatus", selectedStatus);

  return (
    <div className="timesheet_dropdown_wrapper">
      <SelectDropdown
        options={statusOptions}
        value={selectedStatus}
        setSelectedOption={setSelectedStatus}
        name="Approval Action"
        isDisable={false}
        isSearchable={false}
        preventKeyboardOpen={true}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default ApprovalStatusFilter;
